import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function AlertDialog({ open, confirm }) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={confirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Remover chat"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Não é possível remover a mensagem inicial.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirm} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
